/* Decottaa teması – genel davranışlar */
(() => {
  const theme = window.theme || {};
  const routes = theme.routes || {};
  const strings = theme.strings || {};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const debounce = (fn, wait) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), wait);
    };
  };

  let toastTimer;
  const toast = (message) => {
    const el = $('#toast');
    if (!el || !message) return;
    el.textContent = message;
    el.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('visible'), 3200);
  };

  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* Başlık */
  document.addEventListener('click', (event) => {
    const mobileTrigger = event.target.closest('.mobile-trigger');
    if (mobileTrigger) {
      const menu = document.getElementById(mobileTrigger.getAttribute('aria-controls'));
      if (!menu) return;
      const open = menu.hidden;
      menu.hidden = !open;
      mobileTrigger.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
      return;
    }

    const searchToggle = event.target.closest('.search-toggle');
    if (searchToggle) {
      const drawer = document.getElementById(searchToggle.getAttribute('aria-controls'));
      if (!drawer) return;
      drawer.hidden = !drawer.hidden;
      searchToggle.setAttribute('aria-expanded', String(!drawer.hidden));
      if (!drawer.hidden) $('input[type="search"]', drawer)?.focus();
      return;
    }

    const navTrigger = event.target.closest('.nav-drop-trigger');
    if (navTrigger) {
      const drop = navTrigger.closest('[data-nav-drop]');
      const open = !drop.classList.contains('is-open');
      drop.classList.toggle('is-open', open);
      navTrigger.setAttribute('aria-expanded', String(open));
      return;
    }

    $$('[data-nav-drop].is-open').forEach((drop) => {
      if (!drop.contains(event.target)) closeNavDrop(drop);
    });
  });

  function closeNavDrop(drop, focusTrigger = false) {
    drop.classList.remove('is-open');
    const trigger = $('.nav-drop-trigger', drop);
    trigger?.setAttribute('aria-expanded', 'false');
    if (focusTrigger) trigger?.focus();
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    $$('[data-nav-drop].is-open').forEach((drop) => closeNavDrop(drop, true));
    const mobileMenu = $('#MobileMenu');
    if (mobileMenu && !mobileMenu.hidden) {
      mobileMenu.hidden = true;
      const trigger = $('.mobile-trigger');
      trigger?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      trigger?.focus();
    }
  });

  /* Anlık arama: ilk odakta yüklenir */
  const loadPredictiveSearch = () => {
    if (theme.predictiveSearchLoading || !theme.assets || !theme.assets.predictiveSearch) return;
    theme.predictiveSearchLoading = true;
    const script = document.createElement('script');
    script.src = theme.assets.predictiveSearch;
    script.async = true;
    document.head.appendChild(script);
  };
  document.addEventListener('focusin', (event) => {
    if (event.target.closest('predictive-search')) loadPredictiveSearch();
  });

  /* Favoriler */
  const FAV_KEY = 'decottaa-favs';
  const readFavorites = () => {
    try {
      const value = JSON.parse(localStorage.getItem(FAV_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };
  const writeFavorites = (list) => {
    try {
      localStorage.setItem(FAV_KEY, JSON.stringify(list));
    } catch (error) {}
  };
  const syncFavorites = (root = document) => {
    const favorites = readFavorites();
    $$('[data-fav-count]').forEach((badge) => {
      badge.textContent = String(favorites.length);
      badge.hidden = favorites.length === 0;
    });
    $$('[data-fav]', root).forEach((button) => {
      const active = favorites.includes(button.dataset.fav);
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fav]');
    if (!button) return;
    const handle = button.dataset.fav;
    let favorites = readFavorites();
    const adding = !favorites.includes(handle);
    favorites = adding ? [...favorites, handle] : favorites.filter((item) => item !== handle);
    writeFavorites(favorites);
    syncFavorites();
    toast(adding ? strings.favAdded : strings.favRemoved);
    document.dispatchEvent(new CustomEvent('favorites:change', { detail: { favorites } }));
  });

  /* Sepet */
  const updateCartCount = (count) => {
    $$('[data-cart-count-bubble]').forEach((bubble) => {
      bubble.textContent = String(count);
      bubble.hidden = Number(count) === 0;
    });
  };

  const cartRequest = async (url, body) => {
    const response = await fetch(`${url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      const error = new Error(data.description || data.message || strings.cartError);
      error.data = data;
      throw error;
    }
    return data;
  };

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = $('dialog', this);
      if (!this.dialog) return;
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.closest('[data-cart-close]')) this.close();
        else this.onLineAction(event);
      });
      this.dialog.addEventListener('change', (event) => {
        const input = event.target.closest('[data-cart-qty-input]');
        if (input) this.changeLine(input.closest('[data-line]'), Number(input.value));
      });
    }

    open(trigger) {
      if (!this.dialog || this.dialog.open) return;
      this.lastFocus = trigger || document.activeElement;
      this.dialog.showModal();
      document.body.classList.add('menu-open');
      this.dialog.addEventListener(
        'close',
        () => {
          document.body.classList.remove('menu-open');
          this.lastFocus?.focus?.();
        },
        { once: true }
      );
    }

    close() {
      this.dialog?.close();
    }

    renderContent(html) {
      if (!html) return;
      const fresh = $('#CartDrawerContent', parseHTML(html));
      const current = $('#CartDrawerContent', this);
      if (fresh && current) {
        current.replaceWith(fresh);
        updateCartCount(fresh.dataset.cartCount || 0);
      }
    }

    onLineAction(event) {
      const step = event.target.closest('[data-cart-qty]');
      const remove = event.target.closest('[data-cart-remove]');
      if (!step && !remove) return;
      const line = event.target.closest('[data-line]');
      if (!line) return;
      if (remove) {
        this.changeLine(line, 0);
        return;
      }
      const input = $('[data-cart-qty-input]', line);
      const increment = Number(input.step) || 1;
      const next = Math.max(0, Number(input.value) + (step.dataset.cartQty === 'plus' ? increment : -increment));
      input.value = next;
      this.changeLine(line, next);
    }

    async changeLine(line, quantity) {
      if (!line) return;
      const content = $('#CartDrawerContent', this);
      content?.classList.add('is-loading');
      try {
        const data = await cartRequest(routes.cartChange, {
          line: Number(line.dataset.line),
          quantity,
          sections: 'cart-drawer',
          sections_url: window.location.pathname,
        });
        this.renderContent(data.sections && data.sections['cart-drawer']);
        updateCartCount(data.item_count);
      } catch (error) {
        toast(error.message);
        content?.classList.remove('is-loading');
      }
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  const getDrawer = () => (theme.cartType === 'drawer' ? $('cart-drawer') : null);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-open]');
    if (!opener) return;
    const drawer = getDrawer();
    if (!drawer) return;
    event.preventDefault();
    drawer.open(opener);
  });

  theme.addToCart = async (formData, trigger) => {
    const drawer = getDrawer();
    const body = { items: [{ id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) }] };
    if (drawer) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
    }
    const data = await cartRequest(routes.cartAdd, body);
    if (drawer) {
      drawer.renderContent(data.sections && data.sections['cart-drawer']);
      drawer.open(trigger);
    } else {
      const cart = await fetch(`${routes.cart}.js`).then((response) => response.json());
      updateCartCount(cart.item_count);
      toast(strings.addedToCart);
    }
    return data;
  };

  /* Bölüm betiklerinin yardımcıları */
  theme.utils = { $, $$, debounce, toast, parseHTML, cartRequest, updateCartCount, readFavorites, syncFavorites, reducedMotion };

  document.addEventListener('shopify:section:load', () => syncFavorites());
  document.addEventListener('theme:content', () => syncFavorites());

  syncFavorites();
})();
